
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/green-finance",
      function () {
        return require("private-next-pages/products/green-finance/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/green-finance"])
      });
    }
  